import React, { useEffect, useState } from 'react';
import { Form, DatePicker, ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import kaGE from 'antd/lib/locale/ka_GE';
import './CustomerDateInput.scss';
import moment from 'moment';
import useTranslation from '../../../hooks/translation/useTranslation';

function CustomerDateInput({
  className,
  name,
  label,
  errorMessage,
  rules = [],
  disabled = false,
  minDate,
  maxDate,
}) {
  const [locale, setLocale] = useState();
  const { currentLanguage } = useTranslation();

  useEffect(() => {
    // Update locale based on the selected language
    switch (currentLanguage) {
      case 'ka':
        setLocale(kaGE); // Switch to Georgian
        break;
      default:
        setLocale(enUS); // Default to English
    }
  }, [currentLanguage]);

  return (
    <ConfigProvider locale={locale}>
      <Form.Item
        rules={rules}
        className={`customer-date-input ${className}`}
        name={name}
        label={label}
        help={errorMessage}
        validateStatus={errorMessage && 'error'}
      >
        <DatePicker
          format="DD.MM.YYYY"
          disabled={disabled}
          disabledDate={(current) => {
            if (!current) return false;
            if (maxDate && current > moment(maxDate).endOf('day')) {
              return true;
            }

            if (!minDate) return false;

            return current < moment(minDate).startOf('day');
          }}
          inputReadOnly
        />
      </Form.Item>
    </ConfigProvider>
  );
}

export default CustomerDateInput;
